import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { CardBody, Card } from "reactstrap";
// components
import ALoader from "views/pages/manage/common/a-loader";
import ReceiptsList from "../components/ReceiptsList";
import ReceiptFilterDrawer from "../components/ReceiptFilterDrawer";
import BulkActionBar from "../components/BulkActionBar";
import DepositChequeForm from "../components/DepositChequeForm";
import DepositSuccessContent from "modules/paymentManagement/cash-management/receipt/components/DepositSuccessContent";
import StudentSearchBar from "modules/paymentManagement/cash-management/components/StudentSearchBar";
import TopHeaderBar from "modules/paymentManagement/cash-management/components/TopHeaderBar";
import DocumentViewer from "modules/paymentManagement/cash-management/receipt/components/DocumentViewerModal";
// hooks
import { useFetchList } from "modules/paymentManagement/cash-management/hooks/useFetchList";
import { useFetchBankAccounts, useFetchBankAccount } from "modules/paymentManagement/cash-management/hooks/useFetchBankAccount";
import { getChequeReceiptListApi } from "modules/paymentManagement/cheque-management/receipts/api";
import { updateRequest } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { useModal } from "../../../../../contexts/customModal";
import { useFetchDropdown } from "modules/paymentManagement/cash-management/receipt/hooks/useDropdown";

import { useDepositCheque } from "../../hooks/useDepositCheque";

import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";
// helpers
import { failureToast } from "../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function";
import "modules/paymentManagement/cash-management/styles/cashManagement.scss";
import { useBuTypeNameByBuId } from "modules/paymentManagement/cash-management/hooks/useFetchBuType";
const SEARCH_STYLE = { fontSize: "12px" };
const SEARCH_BY = [
  { key: "psid", value: "By PSID" },
  { key: "referenceNumber", value: "By Cheque Number" },
];

// Defined outside to prevent re-creation
const ViewChequeReceiptPage = () => {
  // 1. URL & Navigation
  const { id: businessAreaId, cashierOffice, depositId } = useParams();
  const navigate = useNavigateToGivenPath();
  const [viewer, setViewer] = useState({
    open: false,
    s3key: "",
  });

  // Memoize navigation to prevent recreation
  const goViewDeposit = useCallback(
    () => navigate(`/admin/cheque-management/deposits/${businessAreaId}/${cashierOffice}`),
    [navigate, businessAreaId, cashierOffice]
  );

  const goBack = ()=>{
    navigate(`/admin/cheque-management`);
  }

  // 2. Data Fetching
  const dropdownValues = useFetchDropdown();
  const { depositCheque, loading: isSubmitting } = useDepositCheque();
  // 3. List Management
  const [searchInput, setSearchInput] = useState("");
  const [searchBy, setSearchBy] = useState("referenceNumber");
  const [state, setState] = useState()

  const {
    rows,
    loading: isListLoading,
    pagination,
    onPageChange,
    onPageSizeChange,
    filters,
    onFilterApply,
    fetchTrackerTimeline
  } = useFetchList(getChequeReceiptListApi, {
    initialPageSize: 100, // Consider lowering this
    businessAreaId,
    depositId,
    cashierOffice,
    statusFilters: ["NOT_DEPOSITED", "DATE_EXTENDED"],
    initialFilters: {},
  },setState);

  //const { bankAccounts } = useFetchBankAccounts();
  const { bankDetails } = useFetchBankAccount(businessAreaId, "CHKL");
  const  bankAccounts = bankDetails ? [bankDetails] : [];
  

  const [selectedIds, setSelectedIds] = useState(new Set());
  const updatedPagination = useMemo(
    () => ({
      ...pagination,
      page: pagination.page + 1, // Adjusting for 1-based UI
    }),
    [pagination]
  );

  // Safety: specific to current page data to prevent calculation errors
  const { selectedReceipts, selectedTotal } = useMemo(() => {
    if (!selectedIds.size) return { selectedReceipts: [], selectedTotal: 0 };

    // Only map items currently visible in rows to ensure data integrity
    const selectedItems = rows.filter((item) => selectedIds.has(item.id));
    const total = selectedItems.reduce(
      (acc, item) => acc + item.amountCollected,
      0
    );

    return { selectedReceipts: selectedItems, selectedTotal: total };
  }, [selectedIds, rows]);

  // Logic: Reset selection when page changes to prevent "Ghost selections"
  useEffect(() => {
    setSelectedIds(new Set());
  }, [pagination.page]);

     useEffect(() => {
    if (!depositId) return;

    (async () => {
  
      setSelectedIds(new Set(rows?.map(item => item.id) || []));
      const depositSlip = rows.length ? rows[0] : null;
    })();
  }, [depositId, businessAreaId, rows]);

  // 5. Modal & Form Logic
  const { showModal, hideModal } = useModal();

  const onSaveDepositForm = useCallback(
    (form) => {
      hideModal();
    },
    [hideModal]
  );

  const refreshReceiptList = useCallback(
    (response) => {
      onFilterApply({});
      setSelectedIds(new Set());

      showModal({
        title: `Cheque/DD send for deposition`,
        content: (
          <DepositSuccessContent
            onClose={hideModal}
            details={response}
            onView={goViewDeposit}
            isCheque={true}
          />
        ),
        maxWidth: "lg",
      });
    },
    [onFilterApply, showModal, goViewDeposit, hideModal]
  );

  // 6. Filter Handlers
  const applyFilterHandler = useCallback(
    (newFilter) => {
      onFilterApply(updateRequest(newFilter));
    },
    [onFilterApply]
  );

  const applyPrimaryFilter = useCallback(() => {
    onFilterApply({ [searchBy]: searchInput });
  }, [onFilterApply, searchBy, searchInput]);

  const openDepositSlipModal = useCallback(() => {
    showModal({
      title: `Cheque/DD send for deposition`,
      content: (
        <DepositChequeForm
          totalAmount={selectedTotal}
          onSave={onSaveDepositForm}
          chequeCount={selectedIds.size}
          bankAccounts={bankAccounts}
          refreshReceiptList={refreshReceiptList}
          businessAreaId={businessAreaId}
          isSubmitting={isSubmitting}
          selectedReceipts={selectedReceipts}
          state={state}
          setState={setState}
        />
      ),
      maxWidth: "lg",
    });
  }, [
    showModal,
    selectedTotal,
    onSaveDepositForm,
    selectedIds.size,
    isSubmitting,
  ]);

  const removeFilterFormHandler = useCallback(() => {
    onFilterApply({});
  }, [onFilterApply]);
 const { buTypeName, loading } = useBuTypeNameByBuId(businessAreaId)
  // 7. Render Helpers
  const headerData = useMemo(
    () => ({
      Type: buTypeName,
      BU: businessAreaId,
      "Cashier's office": businessAreaId,
    }),
    [businessAreaId,buTypeName]
  );

  const onViewCheque = (row) => {
    setViewer({ open: true, s3key: row?.attachmentS3Key });
  };

  return (
    <>
      <div className="remove-container-top-space">
        <TopHeaderBar  onBackClick ={goBack} title="Deposit cheques" headerData={headerData} />

        <div className="cm-container">
          {(isSubmitting || isListLoading || loading) && <ALoader position="fixed" />}

          <Card>
            <CardBody>
              <div className="d-flex justify-content-between mb-3">
                <div className="heading-3 color-black semi-bold">
                  Select cheque to deposit
                </div>

                <div className="d-flex gap-md">
                  <div>
                    <StudentSearchBar
                      searchValue={searchInput}
                      onChange={setSearchInput}
                      onSearchClick={applyPrimaryFilter}
                      dropdownValue={searchBy}
                      onDropdownChange={setSearchBy}
                      dropdownStyles={SEARCH_STYLE}
                      dropdownOptions={SEARCH_BY}
                    />
                  </div>

                  <ReceiptFilterDrawer
                    applyFilterHandler={applyFilterHandler}
                    appliedForm={filters}
                    dropdownValues={dropdownValues}
                    onRemoveFilterHandler={removeFilterFormHandler}
                  />
                </div>
              </div>

              <ReceiptsList
                rows={rows}
                loading={isListLoading}
                pagination={updatedPagination}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                selectedIds={selectedIds}
                onSelectionChange={setSelectedIds}
                onViewCheque={onViewCheque}
                fetchTrackerTimeline={fetchTrackerTimeline}
                />
            </CardBody>
          </Card>
        </div>
      </div>

      <BulkActionBar
        count={selectedIds.size}
        totalAmount={selectedTotal}
        onProceed={openDepositSlipModal}
        onViewDeposit={openDepositSlipModal}
        isApiCalling={isSubmitting}
      />

      <DocumentViewer
        open={viewer.open}
        onClose={() => setViewer({ open: false, s3key: "" })}
        s3Key={viewer.s3key}
      />
    </>
  );
};

export default ViewChequeReceiptPage;
